import Navbar from "../src/components/navbar/Navbar";
import Homepage from "../src/components/homepage/Homepage";



function App() {
  return (
    <div className="App">
      <Navbar />
      <Homepage />
    </div>
  );
}

export default App;
